import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { Building2, MapPin, Landmark, Star } from "lucide-react";

const KomikLodz = () => (
  <SeoPageLayout title="Komik i stand-up" titleAccent="Łódź">
    <SeoSection title="Występy komediowe w Łodzi">
      <p>Łódź to miasto, które w ostatnich latach przeszło dynamiczną transformację - z dawnego centrum przemysłu włókienniczego w nowoczesne miasto biznesu, kultury i kreatywności. Oferujemy profesjonalne występy komediowe na terenie Łodzi i województwa łódzkiego, od intymnych spotkań firmowych po duże eventy korporacyjne.</p>
    </SeoSection>
    <SeoSection title="Eventy firmowe w Łodzi">
      <p>Łódź przyciąga coraz więcej firm z branży IT, BPO, logistycznej i kreatywnej. Centralne położenie miasta sprawia, że jest idealnym miejscem na ogólnopolskie konferencje i spotkania integracyjne. Stand-up komediowy w łódzkich postindustrialnych przestrzeniach tworzy wyjątkową atmosferę, łącząc nowoczesność z historycznym klimatem.</p>
    </SeoSection>
    <SeoSection title="Popularne lokalizacje eventowe w Łodzi">
      <SeoFeatureGrid features={[
        { icon: Landmark, title: "Manufaktura", description: "Kompleks handlowo-rozrywkowy z przestrzeniami eventowymi" },
        { icon: Star, title: "EC1", description: "Centrum Nauki i Techniki - nowoczesna lokalizacja" },
        { icon: MapPin, title: "OFF Piotrkowska", description: "Kreatywna przestrzeń eventowa w sercu miasta" },
        { icon: Building2, title: "Pałace fabrykanckie", description: "Pałac Poznańskiego, Herbsta - unikalne wnętrza" },
      ]} />
    </SeoSection>
    <SeoSection title="Zamów komika w Łodzi">
      <p>Planujesz event firmowy w Łodzi? Dzięki centralnemu położeniu miasta łatwo dotrzeć tu z całej Polski. Skontaktuj się z nami - zaproponujemy występ komediowy idealnie dopasowany do Twojego wydarzenia.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikLodz;
